export default __webpack_public_path__ + "static/contact-side-897251123de5d07295fe0b589511966e.svg";